<script setup>
// Istatistikler bolumunun kabugu.
//
// Dort sekme de ayni reklam hesabini kullanir; hesap secicisini her sayfaya
// ayri koymak yerine kabukta tutuyoruz ki kullanici hesabi bir kez sectiginde
// sekmeler arasinda gezerken secim korunsun.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import MetaAdsKabuk from './MetaAdsKabuk.vue';

const { t } = useI18n();

// Sekme adlari computed; dil degistiginde basliklar yeniden cevrilsin diye
// sabit bir dizi yerine hesaplanan deger kullaniliyor.
const sekmeler = computed(() => [
  {
    ad: t('META_ADS.ISTATISTIKLER.SEKME.PERFORMANS'),
    rota: 'meta_ads_performans',
  },
  {
    ad: t('META_ADS.ISTATISTIKLER.SEKME.RAPORLAR'),
    rota: 'meta_ads_raporlar',
  },
  {
    ad: t('META_ADS.ISTATISTIKLER.SEKME.POTANSIYEL_MUSTERILER'),
    rota: 'meta_ads_potansiyel_musteriler',
  },
  {
    ad: t('META_ADS.ISTATISTIKLER.SEKME.DONUSUMLER'),
    rota: 'meta_ads_donusumler',
  },
]);
</script>

<template>
  <MetaAdsKabuk
    :baslik="t('META_ADS.ISTATISTIKLER.BASLIK')"
    :sekmeler="sekmeler"
    :hesap-gerekli="true"
  />
</template>
